import apiService from '@/state/services/Api'
import authService from '@/state/services/Auth'

const getCrmParams = (order) => {
  const account = order.company.substr(0, order.company.indexOf(' '))
  const salesOrder = order.delivery_order_number
  return { account, salesOrder }
}

const orders = {
  namespaced: true,
  state: {
    pk: 'delivery_order_number',
  },
  getters: {
    pk(state) {
      return state.pk
    },
  },
  mutations: {},
  actions: {
    get() {
      return apiService.query(`orders/`).then((data) => {
        return data
      })
    },
    getSalesOrder({ state, commit, dispatch }, order) {
      const { account, salesOrder } = getCrmParams(order)
      const config = {
        baseURL: `https://prod-188.westeurope.logic.azure.com/workflows/8dfc7f2a1c8c4079b5f84a5d4ab6ba6b/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=KLNwvjzg7nF2qJWxLfxfxmnnIm9HNl6F3ybQGeU2ki4&account=${account}&salesorder=${salesOrder}`,
        responseType: 'blob',
      }
      return authService.get(``, config).then((data) => {
        return data
      })
    },
  },
}

export default orders
